module.exports = __webpack_public_path__ + "static/media/paso-1.c8b9b1c1.png";